import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import cookies_en from './locales/en/cookies.json';
import cookies_fr from './locales/fr/cookies.json';
import cookies_sv from './locales/sv/cookies.json';
import validation_en from './locales/en/validation.json';
import validation_fr from './locales/fr/validation.json';
import validation_sv from './locales/sv/validation.json';
import quoteForm_en from './locales/en/quoteForm.json';
import quoteForm_fr from './locales/fr/quoteForm.json';
import quoteForm_sv from './locales/sv/quoteForm.json';

i18n.use(initReactI18next).init({
  resources: {
    en: {
      cookies: cookies_en,
      validation: validation_en,
      quoteForm: quoteForm_en,
    },
    sv: {
      cookies: cookies_sv,
      validation: validation_sv,
      quoteForm: quoteForm_sv,
    },
    fr: {
      cookies: cookies_fr,
      validation: validation_fr,
      quoteForm: quoteForm_fr,
    },
  },
  lng: process.env.GATSBY_USER_LOCALE || 'en',
  interpolation: {
    escapeValue: false,
  },
});

export default i18n;
